import { useDispatch, useSelector } from 'react-redux';
import { AppState } from '../../../../../types/state/AppState';
import { CloManagerAnalyticsFilter } from '../../../../../types/analytics/AnalyticsFilter';
import { TreeSelectOption } from '../../../../controls/TreeSelect';
import { AnalyticsWidget } from '../../../../amrPipeline/common/analytics/AnalyticsWidget';
import { cloManagersActions } from '../../../../../actions/clo-managers.actions';
import { CloManagerAccessTypes } from '../../../../../types/amr-pipeline/enums/CloManagerAccessType';
import { SubscriptionFeature } from '../../../../../types/billing/SubscriptionFeature';
import { ProfileViewHistoryTable } from '../../../../common/manager-analytics/ProfileViewHistoryTable';
import { profileViewHistoryColumns } from './profileViewHistory.columns';
import { GetAction, withAnalyticsRequest } from '../../../../common/manager-analytics/withAnalyticsRequest';

interface ProfileViewHistoryWidgetProps {
    companyReferenceName: string;
    isLoaded: boolean;
    users: TreeSelectOption<string>[];
}

const selector = (state: AppState) => state.cloManagers.analytics;

const getAction = (companyReferenceName: string, filter: CloManagerAnalyticsFilter) => {
    return cloManagersActions.profileViewHistoryRequest(
        companyReferenceName,
        filter.date.dateFrom || undefined,
        filter.date.dateTo || undefined,
    );
};

function ProfileViewHistoryWidgetComponent({ companyReferenceName, isLoaded, users }: ProfileViewHistoryWidgetProps) {
    const dispatch = useDispatch();
    const state = useSelector(selector);

    const { profileHistoryViews } = state;
    const { filter, data, numberOfHiddenItems } = profileHistoryViews;

    const handleFilterChange = (filter: CloManagerAnalyticsFilter) => {
        dispatch(cloManagersActions.profileViewHistoryFilterChange(filter));
    };

    return (
        <AnalyticsWidget
            title="Profile View History"
            isLoading={isLoaded}
            users={users}
            onFilterChange={handleFilterChange}
            state={profileHistoryViews}
            tabDefinitions={CloManagerAccessTypes}
            feature={SubscriptionFeature.ManagerProfileAnalytics}
        >
            <ProfileViewHistoryTable
                companyReferenceName={companyReferenceName}
                data={data}
                filter={filter}
                numberOfHiddenItems={numberOfHiddenItems}
                columns={profileViewHistoryColumns()}
                requiredFeature={SubscriptionFeature.ManagerProfileAnalytics}
            />
        </AnalyticsWidget>
    );
}

export const ProfileViewHistoryWidget = withAnalyticsRequest(
    getAction as GetAction,
    selector,
    (state) => state.profileHistoryViews,
)(ProfileViewHistoryWidgetComponent);
